import { useCallback } from 'react';

import { AppTheme } from '@/shared/constants/app-theme.constant';

import { useChangeThemeMutation } from '../../api/change-theme.api';

export const useChangeTheme = () => {
	const [changeThemeMutation] = useChangeThemeMutation();

	return useCallback(
		(theme: AppTheme) => {
			changeThemeMutation({ theme });
		},
		[changeThemeMutation],
	);
};
